


import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType } from '@angular/common/http';
import { BASE_URI, config } from './../../app.config';

@Injectable()

export class SettingsService {



    /** specifying Base URL.*/
    public BASE_URL = BASE_URI.URL;

    constructor(private http: HttpClient) {
        //  console.log("config",config);
        //  console.log("BASE_URL",this.BASE_URL);
    }

    updateOwnPassword(user) {
        return this.http.patch(`${this.BASE_URL}/users/updateOwnPassword`, user);
    };

    getUserSettings() {
        return this.http.get(`${this.BASE_URL}/userSettings`);
    };

    updateUserSettings(payload) {
        return this.http.put(`${this.BASE_URL}/userSettings`, payload);
    };

    deleteAccount() {
        return this.http.delete(`${this.BASE_URL}/userSettings`);
    };

    // defaultUserSettings() {
    //     return this.http.get(`${this.BASE_URL}/defaultUserSettings`);
    // }

    createInstituteDetails(payLoad){
      return this.http.post(`${this.BASE_URL}/create/companyDetails`, payLoad)
    }

}
